<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">Buscador</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<div class="input-group">
									<input @keyup.enter="enter()" v-model="filter.text" class="form-control" placeholder="Buscar...">
									<span class="input-group-btn">
										<button
											ref="btnfilter"
											@click="doFilter()"
											class="btn btn-default">
											<i class="fa fa-search"></i>
										</button>
										<button
											title="Recargar"
											ref="btnreset"
											@click="reset()"
											class="btn btn-default">
											<i class="fa fa-refresh"></i>
										</button>
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<div class="input-group">
									<span class="input-group-addon">
										<input type="checkbox" v-model="filter.allowDate">
									</span>
									<input type="text" class="form-control" :class="{ disabled: !filter.allowDate }" id="daterange-search">
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<div v-for="item in management" class="radio">
									<input type="radio" :value="item.value" :id="item.value" v-model="resource">
									<label :for="item.value"> {{ item.name }} </label>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<div v-for="item in projects" class="radio">
									<input type="radio" :value="item.value" :id="item.value" v-model="resource">
									<label :for="item.value"> {{ item.name }} </label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],

		data () {
			return {
				modal: {
					selector: 'modal-search'
				},

				filter: {
					allowDate: false,
					text: null,
				},

				currentResource: null,
				resource: null,

				management: [
					{
						name: 'Clientes',
						value: 'customers',
					},
					{
						name: 'Presupuestos',
						value: 'budgets',
					},
					{
						name: 'Pedidos',
						value: 'orders',
					},
					{
						name: 'Facturas',
						value: 'invoices',
					},
					{
						name: 'Productos',
						value: 'products',
					},
					{
						name: 'Proveedores',
						value: 'providers',
					},
				],

				projects: [
					{
						name: 'Proyectos',
						value: 'projects',
					},
					{
						name: 'Tareas',
						value: 'tasks',
					},
				]
			}
		},
		created() {
			this.initDate()
		},
		methods: {
			open(resource = null) {
				if(resource) {
					this.currentResource = resource
					this.resource = this.currentResource
				}
				this.reset()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			initDate() {
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('#daterange-search').daterangepicker({
					"startDate": startDate.format('DD/MM/YY'),
					"endDate": endDate.format('DD/MM/YY'),
					"locale": {
						"format": "DD/MM/YY",
						"separator": " - ",
						"applyLabel": "Aceptar",
						"cancelLabel": "Cancelar",
						"fromLabel": "From",
						"toLabel": "To",
						"customRangeLabel": "Custom",
						"daysOfWeek": [
							"Do",
							"Lu",
							"Ma",
							"Mi",
							"Ju",
							"Vi",
							"Sa",
						],
						"monthNames": [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Septiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						"firstDay": 1
					}
				})
			},
			reset() {
				this.resource = this.currentResource
				this.filter.text = null
				this.filter.allowDate = false
				this.initDate()
			},
			doFilter() {
				this.close()
				var query = {}
				if(this.filter.text) {
					query.text = this.filter.text
				}
				if(this.filter.allowDate) {
					query.date = $('#daterange').val()
				}

				var path = this.getPath()

				this.reset()

				if(path) {
					this.$router.push({
						path: path,
						query: query
					})
				}
			},
			enter() {
				if(this.filter.text) {
					this.doFilter()
				}
			},
			getPath() {
				var path = null
				if(this.resource == 'customers') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/customers'
				}
				if(this.resource == 'budgets') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/budgets'
				}
				if(this.resource == 'orders') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/orders'
				}
				if(this.resource == 'invoices') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/invoices'
				}
				if(this.resource == 'providers') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/providers'
				}

				if(this.resource == 'projects') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects/projects'
				}
				if(this.resource == 'tasks') {
					path = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/projects/tasks'
				}
				return path
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/search/layout/Search.vue